import { memo, FC, CSSProperties } from 'react';
import { clx } from 'Utils';
import { LoadingMask, SkeletonWrapper } from 'Elements';
import styles from 'partials/card/event-invited-card.module.scss';

interface Props {
	count?: number | string;
}

const Skeleton = memo(({ style }: { style: CSSProperties }) => {
	return (
		<div className={styles.card} style={style}>
			<div className="d-flex align-items-center">
				<div className="flex-grow-1">
					<LoadingMask
						className={clx(styles.loadingCol, styles.loadingColLg)}
					/>
					<LoadingMask
						className={clx(styles.loadingCol, styles.loadingColMd)}
					/>
				</div>
			</div>
		</div>
	);
});

export const InviteContactGroupCardLoading: FC<Props> = memo(
	({ count = 4 }) => {
		return <SkeletonWrapper count={count} skeleton={Skeleton} />;
	}
);

Skeleton.displayName = 'Skeleton';

InviteContactGroupCardLoading.displayName = 'InviteContactGroupCardLoading';
